import { PROTOTYPE_MOBILE_PREFIX } from "../mobileRoutePrefix";

/** Sliding Puzzle Quest — isolated routes (no UserLayout / site chrome). */
export const SLIDING_PUZZLE_QUEST_TITLE = "Sliding Puzzle Quest";

const SLIDING_BASE = `${PROTOTYPE_MOBILE_PREFIX}/sliding`;

export const MAIN_PATH = SLIDING_BASE;
export const PLAY_PATH = `${SLIDING_BASE}/play`;
export const LIBRARY_PATH = `${SLIDING_BASE}/library`;
export const MY_PUZZLES_PATH = `${SLIDING_BASE}/my-puzzles`;
export const SETTINGS_PATH = `${SLIDING_BASE}/settings`;

/** App Store screenshot draft pages (same pattern as mobile-jigsaw). */
export const SCREENSHOTS_MAIN_PATH = `${SLIDING_BASE}/screenshots`;
export const SCREENSHOT_SCENE_PATH = `${SLIDING_BASE}/screenshot/:slug`;

/** Google Play Feature Graphic capture — 1024×500 (uses screenshot/05 puzzle). */
export const FEATURE_GRAPHIC_PATH = `${SLIDING_BASE}/feature-graphic`;

/** Instagram Feature Graphic capture — 1080×1080 (Play graphic scaled to square). */
export const FEATURE_GRAPHIC_INSTAGRAM_PATH = `${SLIDING_BASE}/feature-graphic-instagram`;

/**
 * 1080p ending capture — feature graphic fits fully in the viewport (contain, no crop).
 * Popup size: 1920×1080 (see PrototypeMain).
 */
export const RECORDING_ENDING_PATH = `${SLIDING_BASE}/recording/ending`;

/**
 * 1080p featured-graphic recording — same art as `/feature-graphic`, fitted
 * to the viewport for OBS window capture (contain).
 */
export const RECORDING_FEATURE_GRAPHIC_PATH = `${SLIDING_BASE}/recording/feature-graphic`;

/** App Store / Play Store icon capture — 512×512 (uses screenshot/05 puzzle). */
export const APP_ICON_PATH = `${SLIDING_BASE}/app-icon`;

/** Minimal app icon v2 — waffle face + empty slot only (512×512). */
export const APP_ICON_2_PATH = `${SLIDING_BASE}/app-icon-2`;

/** App icon 3 — full-bleed 2×2 glass tiles, bottom-right tile lifted 10° (512×512). */
export const APP_ICON_3_PATH = `${SLIDING_BASE}/app-icon-3`;

/** Same tiles as app icon 3, transparent canvas for Facebook (512×512). */
export const APP_ICON_FACEBOOK_PATH = `${SLIDING_BASE}/app-icon-facebook`;

export function screenshotPath(slug) {
    return `${SLIDING_BASE}/screenshot/${slug}`;
}

/** Demo board image under `public/`. */
export const DEMO_IMAGE = `${process.env.PUBLIC_URL || ""}/v4/sliding-logo-board.png`;

export const QUICK_PLAY_GRID = 4;
export const CHALLENGE_GRID = 6;

export const DIFFICULTIES = ["easy", "medium", "hard"];

export const DIFFICULTY_LABELS = {
    easy: "Easy",
    medium: "Medium",
    hard: "Hard",
};
